/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-attachments-list-display-error',
    templateUrl: './attachments-list-display-error.component.html',
    styleUrls: ['./attachments-list-display-error.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AttachmentsListDisplayErrorComponent {

    @Input() fileManagerOffline = true;

    extension = 'ERROR';

    constructor() {
    }

    @Input() refreshAttachments: Function = () => {
    };
}
